<template>
	<AppCardPage>
		<AppCard title="Optimalisatie" card-id="optimalisatie" :collapsible="true">
			<SchemaForm :schema="schema" class="page-form" />
		</AppCard>
		<AppCard
			v-if="showValues"
			title="Dev - modelvalues"
			card-id="optimalisatieModel"
			:collapsible="true"
		>
			<pre>{{ stringifyObject(formValues) }}</pre>
		</AppCard>
	</AppCardPage>
</template>

<script setup lang="ts">
import { inject, toRef } from "vue";
import useOptimalisatie from "@/store/optimalisatie/useOptimalisatie";
import { SchemaForm, useSchemaForm } from "formvuelate";
import { stringifyObject } from "@/helpers/uiHelpers";
import { toReactive } from "@vueuse/core";

const { state } = useOptimalisatie();

const formValues = toReactive(toRef(state, "values"));
useSchemaForm(formValues);

const schema = state.schema;
const showValues = inject("DEBUG_SHOW_MODELVALUES", false);
</script>
